import React, { useState, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { IoChevronBackSharp } from 'react-icons/io5';
import Rating from '@mui/material/Rating';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { BiSolidEdit } from 'react-icons/bi';
import { FiLink } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import { CiShare2 } from 'react-icons/ci';
import { FaCalendarCheck } from 'react-icons/fa';
import { MdEmojiEvents } from 'react-icons/md';
import { MdOutlineMessage } from 'react-icons/md';
import { FaMobileAlt } from 'react-icons/fa';
import { IoVolumeHighOutline } from 'react-icons/io5';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';

const Dj = () => {
  const [searchParams] = useSearchParams();
  const [djProfile, setDjProfile] = useState(null);
  const [averageRating, setAverageRating] = useState(0);
  const [totalComments, setTotalComments] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [isError, setIsError] = useState(false);
  const [profile, setProfile] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [userComment, setUserComment] = useState(null);
  const [userRating, setUserRating] = useState(null);
  const [coins, setCoins] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();
  const cancelMsg = () => {
    setGift(false);
    setShowReview(false);
    setBookForm(false);
    setIsError(false);
  };
  const [profileId, setProfileId] = useState('');
  useEffect(() => {
    if (isError) {
      const timeout = setTimeout(() => {
        cancelMsg(); // Set isError to false
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [isError]);

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      try {
        const profileresponse = await fetchWithAuth(API_ENDPOINTS.USERS, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!profileresponse.ok) throw new Error('Failed to fetch data');

        const data = await profileresponse.json();
        setProfile(data);
        console.log(data);
        setProfileId(data?.id);
        setCoins(Math.round(data?.coins / 2));
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };

    fetchProfile();
  }, []);

  const [events, setEvents] = useState([]);
  useEffect(() => {
    const id = searchParams.get('djId');
    if (!id || !profileId) return;

    const fetchDjProfile = async () => {
      try {
        const token = localStorage.getItem('tringAuthToken');
        const response = await fetchWithAuth(API_ENDPOINTS.RATINGS_ID(id), {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch DJ data');

        const data = await response.json();
        try {
          const token = localStorage.getItem('tringAuthToken');
          const eventsResp = await fetchWithAuth(
            API_ENDPOINTS.VENUES_USER(data?.partner?.id),
            {
              method: 'GET',
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
            }
          );

          if (!eventsResp.ok) throw new Error('Failed to fetch DJ data');

          const eventsData = await eventsResp.json();
          setEvents(eventsData);
        } catch (error) {
          console.error('Failed to fetch DJ data', error);
        }

        const myComment = data.comments.find(
          comment => comment?.user?.id === profileId
        );

        if (myComment && !comment && !rating) {
          setUserComment(myComment?.comment);
          setUserRating(myComment?.rating);
        }
        setDjProfile(data);

        const total = data.comments.length;
        const sum = data.comments.reduce((acc, c) => acc + c.rating, 0);
        const avg = (sum / total).toFixed(1);

        setTotalComments(total);
        setAverageRating(avg);
        // console.log(data);
      } catch (error) {
        console.error('Error fetching DJ data:', error);
      }
    };

    fetchDjProfile();
    const interval = setInterval(fetchDjProfile, 3000);

    return () => clearInterval(interval);
  }, [searchParams, profileId]);

  function goBack() {
    const from = location.state?.from;
    console.log(location);
    if (from && from.includes('/partner')) {
      navigate('/main');
    } else {
      navigate(-1);
    }
  }

  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');

  const handleSubmit = async () => {
    setIsLoading(true);
    if (!comment.trim() || rating === 0) {
      setIsLoading(false);
      setErrorMsg('Please provide both rating and comment');
      setIsError(true);
      return;
    }

    const id = searchParams.get('djId');

    try {
      const token = localStorage.getItem('tringAuthToken'); // Assuming you have this stored

      const response = await fetchWithAuth(API_ENDPOINTS.RATINGS, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          rating: rating,
          partnerId: id,
          comment: comment,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json(); // try to parse the error message
        const errormsg =
          errorData?.message || errorData?.error || 'Something went wrong';
        setIsLoading(false);
        setErrorMsg(errormsg.toString());
        setIsError(true);
        return;
      }

      // console.log("Submitted successfully:", response.data);
      // alert("Rating submitted successfully!");
      setRating(0);
      setComment('');
      setIsLoading(false);
      setShowReview(false);
      setErrorMsg('Review Submitted Successfully');
      setIsError(true);
      setIsEdit(false);
    } catch (error) {
      console.error('Submission failed:', error);
      // alert("Failed to submit rating");
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Invitation Link for Event',
          url: window.document.location.href,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      console.log('Web Share API is not supported in this browser.');
    }
  };

  const [bookForm, setBookForm] = useState(false);

  const bookDj = async e => {
    e.preventDefault();
    setIsLoading(true);
    const form = e.target;

    const formData = {
      bookingDate: form.bookingDate.value,
      eventType: form.eventType.value,
      message: form.message.value,
      mobile: form.mobile.value,
    };

    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      return;
    }
    try {
      const bookResponse = await fetchWithAuth(
        API_ENDPOINTS.USER_REQUEST_RESERVATION,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            bookingDate: form.bookingDate.value,
            eventType: form.eventType.value,
            message: form.message.value,
            phoneNumber: '+91' + form.mobile.value,
            partnerId: djProfile?.partner?.id,
          }),
        }
      );

      if (!bookResponse.ok) {
        setBookForm(false);
        const errorData = await bookResponse.json();
        const errormsg =
          errorData?.message || errorData?.error || 'Something went wrong';
        setIsLoading(false);
        setErrorMsg(errormsg.toString());
        setIsError(true);
        return;
      }

      setIsLoading(false);
      setBookForm(false);
      setErrorMsg('Request sent successfully');
      setIsError(true);
    } catch (error) {
      console.error('Failed to book DJ', error);
    }
  };

  const [showReview, setShowReview] = useState(false);
  const [gift, setGift] = useState(false);

  const handleDecrease = () => {
    if (coins > 1) setCoins(coins - 1);
  };

  const handleIncrease = () => {
    setCoins(coins + 1);
  };

  const sendGift = async () => {
    setIsLoading(true);

    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      return;
    }
    try {
      const giftResponse = await fetchWithAuth(
        API_ENDPOINTS.PARTNER_USER_GIFT,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            coins: coins,
            partnerId: djProfile?.partner?.id,
          }),
        }
      );

      if (!giftResponse.ok) {
        setGift(false);
        const errorData = await giftResponse.json();
        const errormsg =
          errorData?.message || errorData?.error || 'Something went wrong';
        setIsLoading(false);
        setErrorMsg(errormsg.toString());
        setIsError(true);
        return;
      }

      setIsLoading(false);
      setGift(false);
      setErrorMsg('Request sent successfully');
      setIsError(true);
    } catch (error) {
      console.error('Failed to send gift', error);
    }
  };

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const formattedTomorrow = tomorrow.toISOString().split('T')[0];

  return (
    <div
      className="py-2"
      style={{
        height: '100dvh',
        paddingLeft: '7%',
        paddingRight: '7%',
        overflow: 'hidden',
      }}
    >
      {!djProfile ? (
        <div className="h-100 w-100 d-flex justify-content-center align-items-center">
          <Spinner
            animation="border"
            role="status"
            style={{
              color: 'red',
              height: '10dvh',
              aspectRatio: '1/1',
              width: '10dvh',
            }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div
          className="h-100 d-flex flex-column "
          style={{ position: 'relative' }}
        >
          {isError && (
            <div
              style={{
                position: 'fixed',
                bottom: '80px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 10000,
                color: 'white',
                background: 'rgba(236, 236, 236, 1)',
                borderRadius: '20px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.32)',
                padding: '16px 24px',
                minWidth: '300px',
                maxWidth: '90vw',
                animation:
                  'slideDown 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
              }}
            >
              <img
                src="/images/logo.svg"
                style={{
                  width: '18px',
                  height: '18px',
                  flexShrink: 0,
                }}
              />
              <div
                style={{
                  color: 'black',
                  fontSize: '13px',
                  lineHeight: '1.4',
                }}
              >
                {typeof errorMsg === 'string'
                  ? errorMsg
                  : errorMsg?.message || 'Something went wrong'}
              </div>
            </div>
          )}
          {isLoading ? (
            <div className="lmodale">
              <div className="loverlay"></div>

              <div className="lmodalecontent">
                <Spinner
                  animation="border"
                  role="status"
                  style={{ color: 'red' }}
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          {bookForm ? (
            <div
              className=""
              style={{
                position: 'absolute',
                top: '0px',
                width: '100%',
                height: '100%',
                backgroundColor: 'white',
                zIndex: 1000,
              }}
            >
              <div className="d-flex flex-row justify-content-between ">
                <span className="mx-2"></span>
                <img
                  src={djProfile?.partner?.avatar}
                  style={{
                    width: '25%',
                    aspectRatio: '1/1',
                    borderRadius: '50%',
                  }}
                />
                <IoMdCloseCircleOutline
                  className="mt-2"
                  style={{ fontSize: '20px' }}
                  onClick={() => cancelMsg()}
                />
              </div>

              <div className="mt-2 d-flex flex-column justify-content-center align-items-center">
                <h4 className="mb-0">
                  <b>{djProfile?.partner?.display_name}</b>{' '}
                  <FaCheckCircle className="mb-1" style={{ color: 'blue' }} />
                </h4>
                <span>Tringbox Verified Partner</span>
                {/* {console.log(djProfile)} */}
                <span>
                  {djProfile?.address?.city} {djProfile?.address?.country}
                </span>
                <span
                  className="d-flex align-items-center justify-content-center my-2"
                  style={{
                    gap: '10px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                  }}
                >
                  {averageRating}{' '}
                  <Rating
                    name="size-medium"
                    className=""
                    value={averageRating}
                    readOnly
                  />{' '}
                  ({totalComments} Reviews)
                </span>
              </div>

              <div className="w-100 p-3 py-4" style={{ background: 'white' }}>
                <form
                  onSubmit={bookDj}
                  className="d-flex flex-column align-items-start w-100"
                  style={{ gap: '12px' }}
                >
                  <div
                    className="d-flex flex-column align-items-start mb-3 w-100"
                    style={{ gap: '7px' }}
                  >
                    <label style={{ color: '#4C4C4C' }}>
                      <b>
                        <FaCalendarCheck /> Booking Date:
                      </b>
                    </label>
                    <input
                      type="date"
                      name="bookingDate"
                      required
                      className="p-1 w-100"
                      style={{
                        border: '1px solid #D8D8D8',
                        borderRadius: '5px',
                      }}
                      defaultValue={formattedTomorrow}
                    />
                  </div>

                  <div
                    className="d-flex flex-column align-items-start mb-3 w-100"
                    style={{ gap: '7px' }}
                  >
                    <label style={{ color: '#4C4C4C' }}>
                      <b>
                        <MdEmojiEvents /> Event Type:
                      </b>
                    </label>
                    <input
                      type="text"
                      name="eventType"
                      placeholder="e.g. Wedding, Birthday"
                      required
                      className="p-1 w-100"
                      style={{
                        border: '1px solid #D8D8D8',
                        borderRadius: '5px',
                      }}
                    />
                  </div>

                  <div
                    className="d-flex flex-column align-items-start mb-3 w-100"
                    style={{ gap: '7px' }}
                  >
                    <label style={{ color: '#4C4C4C' }}>
                      <b>
                        <MdOutlineMessage /> Your Message:
                      </b>
                    </label>
                    <textarea
                      name="message"
                      rows="1"
                      placeholder="Enter message..."
                      required
                      className="p-1 w-100"
                      style={{
                        border: '1px solid #D8D8D8',
                        borderRadius: '5px',
                      }}
                    />
                  </div>

                  <div
                    className="d-flex flex-column align-items-start mb-3 w-100"
                    style={{ gap: '7px' }}
                  >
                    <label style={{ color: '#4C4C4C' }}>
                      <b>
                        <FaMobileAlt /> Mobile Number:
                      </b>
                    </label>
                    <input
                      type="text"
                      name="mobile"
                      pattern="[0-9]{10}"
                      placeholder="10-digit number"
                      required
                      className="p-1 w-100"
                      style={{
                        border: '1px solid #D8D8D8',
                        borderRadius: '5px',
                      }}
                      defaultValue={profile?.phone_number}
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-100 mt-2 p-2 "
                    style={{
                      background:
                        'linear-gradient(90deg, #C81620 -13.89%, #3E286D 93.25%)',
                      border: 'none',
                      color: 'white',
                      borderRadius: '10px',
                    }}
                  >
                    <IoVolumeHighOutline
                      style={{
                        color: 'white',
                        fontSize: '20px',
                        marginBottom: '2px',
                      }}
                    />{' '}
                    Book Now
                  </button>
                </form>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          {showReview ? (
            <div className="emodale">
              <div className="eoverlay" onClick={() => cancelMsg()}></div>

              <div className="emodalecontent" style={{ top: '25dvh' }}>
                <div
                  className="w-100 p-3 d-flex flex-row"
                  style={{
                    background:
                      'linear-gradient(90deg, #C91721 0%, #8A325D 100%)',
                    borderRadius: '5px 5px 0px 0px',
                  }}
                >
                  <div className=" col-12 d-flex flex-row justify-content-between">
                    <span></span>
                    <h3 className="m-0" style={{ color: 'white' }}>
                      Review
                    </h3>

                    <button
                      className=""
                      style={{
                        color: 'white',
                        background: 'transparent',
                        border: 'none',
                      }}
                      onClick={() => cancelMsg()}
                    >
                      <IoMdCloseCircleOutline
                        style={{ color: 'white', fontSize: '25px' }}
                      />{' '}
                    </button>
                  </div>
                </div>

                {/* {errorMsg ? (
                  <div className="w-100">
                    <div
                      className="p-3 w-100"
                      style={{
                        background: "#FFF",
                      }}
                    >
                      <span>
                        {typeof errorMsg === "string"
                          ? errorMsg
                          : errorMsg?.message || "Error occurred"}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )} */}

                <div
                  className="w-100 text-start p-3"
                  style={{
                    background: 'white',
                    borderRadius: '0px 0px 5px 5px',
                  }}
                >
                  <h5
                    className="mb-2 d-flex flex-row align-items-center"
                    style={{ color: '#9A9A9A', gap: '10px' }}
                  >
                    Rate DJ{' '}
                    <Rating
                      name="size-medium"
                      defaultValue={0}
                      value={rating}
                      onChange={(e, newValue) => setRating(newValue)}
                    />
                  </h5>
                  <div
                    className="d-flex flex-column align-items-end"
                    style={{
                      borderRadius: '10px',
                      background: '#F5F5F5',
                      border: 'none',
                      height: '16dvh',
                      gap: '5px',
                    }}
                  >
                    <textarea
                      className="w-100 p-3"
                      placeholder="Add a Comment"
                      style={{
                        background: '#DEDEDE',
                        border: 'none',
                        height: '14dvh',
                        borderRadius: '5px',
                      }}
                      value={comment}
                      onChange={e => setComment(e.target.value)}
                    />
                    <button
                      className="px-2 py-1"
                      onClick={() => handleSubmit()}
                      style={{
                        borderRadius: '10px',
                        background:
                          'linear-gradient(90deg, #C81620 -13.89%, #8A325D 93.25%)',
                        border: 'none',
                        color: 'white',
                        width: '30%',
                        fontSize: '12px',
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          {gift ? (
            <div className="emodale">
              <div className="eoverlay" onClick={() => cancelMsg()}></div>

              <div className="emodalecontent" style={{ top: '25dvh' }}>
                {/* <div
                  className="w-100 p-3 d-flex flex-row"
                  style={{
                    background:
                      "linear-gradient(90deg, #C91721 0%, #8A325D 100%)",
                    borderRadius: "5px 5px 0px 0px",
                  }}
                >
                  <div className=" col-12 d-flex flex-row justify-content-between">
                    <span></span>
                    <h3 className="m-0" style={{ color: "white" }}>
                      Gift coins
                    </h3>

                    <button
                      className=""
                      style={{
                        color: "white",
                        background: "transparent",
                        border: "none",
                      }}
                      onClick={() => cancelMsg()}
                    >
                      <IoMdCloseCircleOutline
                        style={{ color: "white", fontSize: "25px" }}
                      />{" "}
                    </button>
                  </div>
                </div>

                <div
                  className="w-100 text-start p-3"
                  style={{
                    background: "white",
                    borderRadius: "0px 0px 5px 5px",
                  }}
                >
                  <h5
                    className="mb-2 d-flex flex-row align-items-center"
                    style={{ color: "#9A9A9A", gap: "10px" }}
                  >
                    Number of Coins:
                  </h5>
                  <div
                    className="d-flex flex-column align-items-end"
                    style={{
                      borderRadius: "10px",
                      background: "#F5F5F5",
                      border: "none",
                      gap: "5px",
                    }}
                  >
                    <input
                      className="w-100 p-2 my-3"
                      placeholder="Enter amount"
                      style={{
                        borderRadius: "5px",
                      }}
                      value={coins}
                      onChange={(e) => setCoins(e.target.value)}
                    />
                    <button
                      className="px-2 py-1 w-100 mb-2"
                      onClick={() => sendGift()}
                      style={{
                        borderRadius: "5px",
                        background:
                          "linear-gradient(90deg, #C81620 -13.89%, #8A325D 93.25%)",
                        border: "none",
                        color: "white",
                        fontSize: "16px",
                      }}
                    >
                      Send Gift
                    </button>
                  </div>
                </div> */}

                <div
                  className="card p-3 shadow-sm w-100 mx-0"
                  style={{ borderRadius: '16px' }}
                >
                  <div className="d-flex align-items-center mb-2">
                    <span className="me-2 bg-danger text-white p-1 rounded-circle">
                      🎁
                    </span>
                    <h5 className="m-0">Send Appreciation</h5>
                  </div>

                  <p
                    className="text-muted mb-2 text-start"
                    style={{ fontSize: '14px' }}
                  >
                    Make {djProfile?.partner?.display_name}’s day with your
                    love.
                  </p>

                  <hr className="my-2" />

                  <div className="d-flex align-items-center mb-2">
                    <span className="me-2" style={{ fontSize: '20px' }}>
                      🪙
                    </span>
                    <strong>Gift Coins</strong>
                  </div>

                  <div className="d-flex flex-row justify-content-between mb-4 py-2 w-100">
                    <button
                      className="border py-2 px-3"
                      onClick={handleDecrease}
                    >
                      −
                    </button>
                    <input
                      className="p-1 text-center"
                      value={coins}
                      type="number"
                      onChange={e => setCoins(Number(e.target.value))}
                      style={{
                        border: 'none',
                        fontSize: '18px',
                        maxWidth: '55%',
                      }}
                    />

                    <button
                      className="border py-2 px-3"
                      onClick={handleIncrease}
                    >
                      +
                    </button>
                  </div>

                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-danger w-45"
                      onClick={cancelMsg}
                    >
                      ❌ Cancel
                    </button>
                    <button
                      className="btn btn-primary w-45 appreciate-btn"
                      onClick={() => sendGift()}
                    >
                      🎁 Appreciate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}

          <div
            className="h-100 d-flex flex-column position-relative w-100"
            style={{ overflow: 'scroll', scrollBehavior: 'smooth' }}
          >
            <div
              className="col-12 d-flex flex-column my-2 align-items-center"
              style={{ gap: '5px  ', paddingRight: '10px' }}
            >
              {/* <IoIosArrowBack
              style={{ fontSize: "32px" }}
              onClick={() => goBack()}
            /> */}

              <div className="d-flex flex-row justify-content-between ">
                <IoChevronBackSharp
                  className="mt-2"
                  style={{ fontSize: '22px' }}
                  onClick={() => goBack()}
                />
                <img
                  src={djProfile?.partner?.avatar}
                  style={{
                    width: '25%',
                    aspectRatio: '1/1',
                    borderRadius: '50%',
                  }}
                />
                <CiShare2
                  className="mt-2"
                  style={{ fontSize: '22px' }}
                  onClick={() => handleShare()}
                />
              </div>

              <div
                style={{ flexGrow: 1 }}
                className="h-100 d-flex flex-column justify-content-center align-items-center"
              >
                <h4 className="mb-0">
                  <b>{djProfile?.partner?.display_name}</b>{' '}
                  <FaCheckCircle className="mb-1" style={{ color: 'blue' }} />
                </h4>
                <span>Tringbox Verified Partner</span>
                {/* {console.log(djProfile)} */}
                <span>
                  {djProfile?.address?.city} {djProfile?.address?.country}
                </span>
                <span
                  className="d-flex align-items-center justify-content-center my-2"
                  style={{
                    gap: '10px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                  }}
                >
                  {averageRating}{' '}
                  <Rating
                    name="size-medium"
                    className=""
                    value={averageRating}
                    readOnly
                  />{' '}
                  ({totalComments} Reviews)
                </span>
              </div>
            </div>

            <div
              className="col-12 d-flex flex-column justify-content-center mb-3"
              style={{ gap: '5px' }}
            >
              <button
                className="col-12 p-2"
                style={{
                  borderRadius: '10px',
                  background:
                    'linear-gradient(90deg, #C81620 -13.89%, #40286C 93.25%)',
                  border: 'none',
                  color: 'white',
                  fontSize: '14px',
                }}
                onClick={() => setBookForm(true)}
              >
                <b>Book DJ</b>
              </button>
              <button
                className="col-12 p-2"
                style={{
                  border: '1px solid #CC151E',
                  borderRadius: '10px',
                  background: 'white',
                  color: '#CC151E',
                  fontSize: '14px',
                }}
                onClick={() => setGift(true)}
              >
                <b>Gift coin</b>
              </button>
            </div>

            {events.length > 0 && (
              <div className="d-flex flex-column mt-2 mb-3">
                <h6 className="col-12 text-start">
                  <b>Events Hosted ({events.length}) </b>{' '}
                </h6>

                <div
                  className="d-flex flex-row w-100"
                  style={{
                    overflow: 'scroll',
                    scrollBehavior: 'smooth',
                    gap: '5px',
                  }}
                >
                  {events.map((event, index) => (
                    <div
                      key={index}
                      className="p-2 col-5 d-flex flex-row"
                      style={{
                        borderRadius: '10px',
                        border: '1px solid #D8D8D8',
                        overflow: 'hidden',
                        width: '55%',
                      }}
                    >
                      <img
                        src={event?.photoUrl}
                        className="mt-1"
                        style={{
                          height: '28px',
                          width: '28px',
                          borderRadius: '50%',
                        }}
                      />
                      <div
                        className="d-flex flex-column text-start overflow-hidden px-2"
                        style={{ gap: '2px' }}
                      >
                        <span
                          className="mb-0"
                          style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
                        >
                          <b>{event?.name}</b>
                        </span>
                        <span className="" style={{ fontSize: '12px' }}>
                          {event?.updatedAt &&
                            `${new Date(event.updatedAt).getDate()}-${
                              new Date(event.updatedAt).getMonth() + 1
                            }-${new Date(event.updatedAt).getFullYear()}`}
                        </span>

                        <span
                          style={{
                            color: '#D8D8D0',
                            whiteSpace: 'nowrap',
                            fontSize: '12px',
                          }}
                        >
                          {event?.address?.city}, {event?.address?.country}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div
              className="mb-3"
              style={{
                display:
                  djProfile?.partner?.linkedIn ||
                  djProfile?.partner?.linkedIn ||
                  djProfile?.partner?.twitter ||
                  djProfile?.partner?.youtube ||
                  djProfile?.partner?.instagram
                    ? 'block'
                    : 'none',
              }}
            >
              <h6 className="col-12 text-start">
                <b>Social Links</b>
              </h6>
              <div
                className="d-flex flex-row justify-content-start"
                style={{ gap: '5%' }}
              >
                <img
                  src="/images/li.png"
                  onClick={() =>
                    window.open(`${djProfile?.partner?.linkedIn}`, '_blank')
                  }
                  style={{
                    width: '12%',
                    aspectRatio: '1/1',
                    display: djProfile?.partner?.linkedIn ? 'block' : 'none',
                  }}
                />
                <img
                  src="/images/x.png"
                  onClick={() =>
                    window.open(`${djProfile?.partner?.twitter}`, '_blank')
                  }
                  style={{
                    maxWidth: '12%',
                    aspectRatio: '1/1',
                    display: djProfile?.partner?.twitter ? 'block' : 'none',
                  }}
                />
                <img
                  src="/images/yt.png"
                  onClick={() =>
                    window.open(`${djProfile?.partner?.youtube}`, '_blank')
                  }
                  style={{
                    maxWidth: '12%',
                    aspectRatio: '1/1',
                    display: djProfile?.partner?.youtube ? 'block' : 'none',
                  }}
                />
                <img
                  src="/images/inst.png"
                  onClick={() =>
                    window.open(`${djProfile?.partner?.instagram}`, '_blank')
                  }
                  style={{
                    maxWidth: '12%',
                    aspectRatio: '1/1',
                    display: djProfile?.partner?.instagram ? 'block' : 'none',
                  }}
                />
                <FiLink
                  className="h-100 w-100 p-2"
                  onClick={() =>
                    window.open(`${djProfile?.partner?.custom}`, '_blank')
                  }
                  style={{
                    maxWidth: '12%',
                    aspectRatio: '1/1',
                    borderRadius: '14.561px',
                    border: '1px solid #EBEBEB',
                    background: '#FFF',
                    display: djProfile?.partner?.custom ? 'block' : 'none',
                  }}
                />
              </div>
            </div>

            <div
              style={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div className="d-flex flex-row justify-content-between mb-1">
                <h6 className="text-start mb-2">
                  <b>Reviews ({totalComments})</b>
                </h6>
                <h6
                  className="p-1 px-2 "
                  onClick={() => {
                    setShowReview(true);
                    setComment(userComment);
                    setRating(userRating);
                  }}
                  style={{
                    border: '1px solid #C81622',
                    color: '#C81622',
                    borderRadius: '5px',
                    fontSize: '10px',
                  }}
                >
                  Rate Now
                </h6>
              </div>

              <div
                style={{
                  flexGrow: 1,
                }}
              >
                {djProfile?.comments.map((comment, index) => (
                  <div
                    className="col-12 p-2 mb-2"
                    key={index}
                    style={{
                      borderRadius: '10px',
                      border: '1px solid #D8D8D8',
                    }}
                  >
                    <div className="col-12 d-flex flex-row">
                      <div className="col-10 text-start">
                        <div className="w-100 d-flex flex-row align-items-center justify-content-between">
                          <div
                            className="d-flex flex-row align-items-center col-7"
                            style={{ gap: '15px' }}
                          >
                            <img
                              src={comment?.user?.avatar}
                              style={{
                                width: 'clamp(0px,10vw,80px)',
                                borderRadius: '50%',
                                aspectRatio: '1/1',
                              }}
                            />
                            <div className="d-flex flex-column">
                              <span
                                className="mb-0 col-8 overflow-hidden"
                                style={{
                                  whiteSpace: 'nowrap',
                                  fontSize: '15px',
                                  marginLeft: '4px',
                                  fontWeight: 500,
                                }}
                              >
                                {comment?.user?.display_name}
                              </span>
                              <Rating
                                name="size-small"
                                value={comment?.rating}
                                style={{ width: '100px' }}
                                size="small"
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="d-flex flex-column">
                          <span
                            className="mt-1 mb-0"
                            style={{ fontSize: '13px' }}
                            // style={{
                            //   color: "#C0C0C0",
                            //   wordWrap: "break-word",
                            //   overflowWrap: "break-word",
                            //   whiteSpace: "normal",
                            // }}
                          >
                            {comment?.comment}
                          </span>
                          <span
                            style={{
                              color: '#C0C0C0',
                              wordWrap: 'break-word',
                              overflowWrap: 'break-word',
                              whiteSpace: 'normal',
                              fontSize: '12px',
                            }}
                          >
                            {comment?.updatedAt &&
                              `${new Date(comment.updatedAt).getDate()}-${
                                new Date(comment.updatedAt).getMonth() + 1
                              }-${new Date(
                                comment.updatedAt
                              ).getFullYear()} ${new Date(
                                comment.updatedAt
                              ).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                              })}`}
                          </span>
                        </div>
                      </div>
                      <BiSolidEdit
                        className="m-2"
                        style={{
                          fontSize: '23px',
                          color: '#A12846',
                          display:
                            comment?.user?.id === profile?.id
                              ? 'block'
                              : 'none',
                        }}
                        onClick={() => {
                          setShowReview(true);
                          setRating(comment?.rating);
                          setComment(comment?.comment);
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* <div
            className="w-100 text-start mt-2"
            style={{ display: isEdit ? "block" : isEdit2 ? "block" : "none" }}
          >
            <h5
              className="mb-2 d-flex flex-row align-items-center"
              style={{ color: "#9A9A9A", gap: "10px" }}
            >
              Rate DJ{" "}
              <Rating
                name="size-medium"
                defaultValue={0}
                value={rating}
                onChange={(e, newValue) => setRating(newValue)}
              />
            </h5>
            <div
              className="d-flex flex-column align-items-end"
              style={{
                borderRadius: "10px",
                background: "#F5F5F5",
                border: "none",
                height: "12dvh",
                gap: "5px",
              }}
            >
              <textarea
                className="w-100 p-2"
                placeholder="Add a Comment"
                style={{
                  background: "#F5F5F5",
                  border: "none",
                  height: "10dvh",
                }}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
              <button
                className="p-1"
                onClick={() => handleSubmit()}
                style={{
                  borderRadius: "10px",
                  background:
                    "linear-gradient(90deg, #C81620 -13.89%, #8A325D 93.25%)",
                  border: "none",
                  color: "white",
                  width: "30%",
                  fontSize: "12px",
                }}
              >
                Submit
              </button>
            </div>
          </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dj;
